import { Reveal } from "@/components/Reveal";

const IgIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" ry="5" fill="none" stroke="currentColor" strokeWidth="1.8" />
    <circle cx="12" cy="12" r="4.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
    <circle cx="17.4" cy="6.6" r="1.1" fill="currentColor" stroke="none" />
  </svg>
);

export const Cta = () => (
  <section id="kontakt" className="px-6 py-16 text-center md:py-24" data-testid="cta-section">
    <div className="mx-auto max-w-[920px]">
      <Reveal>
        <span className="font-mono2 text-[11px] font-bold uppercase tracking-[0.22em] md:text-xs">
          Bleibt dran
        </span>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display mx-auto mt-5 max-w-[640px] text-[clamp(1.8rem,5vw,2.8rem)] uppercase leading-[1.05] tracking-tight">
          Als Erste·r erfahren, wenn's losgeht.
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <a
          href="https://www.instagram.com/housegemachtt"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-cta-button"
          className="font-mono2 mt-9 inline-flex items-center gap-3 border-2 border-[#f4f4f2] bg-[#f4f4f2] px-8 py-4 text-sm font-bold uppercase tracking-[0.08em] text-[#0a0a0a] transition-colors duration-200 hover:bg-transparent hover:text-[#f4f4f2]"
        >
          <IgIcon />
          Folgt uns auf Instagram
        </a>
      </Reveal>
      <Reveal delay={0.25}>
        <p className="font-mono2 mt-5 text-[11px] font-medium text-[#a8a8a4]">
          Alle Updates zum ersten Event gibt's zuerst dort.
        </p>
      </Reveal>
    </div>
  </section>
);
